export default {
      id: "191,9_cm_=_90_+_35_+_28,4_+_35-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#191,9_cm_=_90_+_35_+_28,4_+_35",
      toString: function () {
        return this.url;
      }
    }